import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'postcode',
  standalone: true
})
export class PostcodePipe implements PipeTransform {

  transform(val: number): string {
    let value = val.toString();
    console.log("pipe")
    if (value && value.length > 2) {
      return value.substring(0, 2) + ' ' + value.substring(2);
    }
    return value;  // return original value if it's less than 2 digits
  }
}
